import React, { useState } from "react";
import DeleteButton from "../../../components/admin/usable/actions/DeleteButton";
import Box from "@mui/joy/Box";
import Drawer from "@mui/joy/Drawer";
import Button from "@mui/joy/Button";
import List from "@mui/joy/List";
import Divider from "@mui/joy/Divider";
import ListItem from "@mui/joy/ListItem";
import ListItemButton from "@mui/joy/ListItemButton";
import Filtering from "./Filtering";

const MobileFilter = () => {
  const [isShow, setIsShow] = useState(false);
  const [open, setOpen] = React.useState(true);

  const toggleDrawer = (inOpen) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setOpen(inOpen);
  };

  return (
    <>
      {isShow && (
        <div
          className="fixed inset-0 bg-black/50 flex justify-center items-center z-40"
          onClick={() => {
            setIsShow(false);
            toggleDrawer(false)();
          }}
        >
          <div className="max-h-[70vh] overflow-y-auto p-3">
            <Box
              sx={{
                display: "flex",
              }}
            >
              <Drawer
                slotProps={{
                  content: {
                    sx: {
                      borderTopLeftRadius: 20,
                      borderTopRightRadius: 20,
                    },
                  },
                }}
                anchor="bottom"
                open={open}
                onClose={toggleDrawer(false)}
              >
                <Box
                  role="presentation"
                  onClick={toggleDrawer(false)}
                  onKeyDown={toggleDrawer(false)}
                >
                  <div className="p-3" onClick={(e) => e.stopPropagation()}>
                    <Filtering />
                  </div>
                </Box>
              </Drawer>
            </Box>
          </div>
        </div>
      )}

      <button
        onClick={() => {
          setIsShow(true);
          toggleDrawer(true)();
        }}
        className="fixed bottom-20 left-1/2 -translate-x-1/2 bg-blue-800 text-white px-4 py-2 rounded-full text-xs z-30 lg:hidden shadow-md"
      >
        Filter Options
      </button>
    </>
  );
};

export default MobileFilter;
